import { render } from "./AppFooter.vue?vue&type=template&id=fa8efa32"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/layout/AppFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fa8efa32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fa8efa32', __exports__)) {
    api.reload('fa8efa32', __exports__)
  }
  
  module.hot.accept("./AppFooter.vue?vue&type=template&id=fa8efa32", () => {
    api.rerender('fa8efa32', render)
  })

}


export default __exports__